import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
import { Button } from "@/components/button";
import { FormTextarea } from "@/components/form";
import { useComposerStore } from "@/stores/composers";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
import { ComposerShell } from "./composer-shell";
/** Plain text composer used by types without a bespoke form yet. */
export function GenericComposerBody(_ref) {
  var composer = _ref.composer;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var close = useComposerStore(function (state) {
    return state.close;
  });
  var setContent = useComposerStore(function (state) {
    return state.setContent;
  });
  return /*#__PURE__*/React.createElement(ComposerShell, {
    composerId: composer.id,
    title: composer.title,
    subtitle: composer.subtitle,
    footer: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      variant: "ghost",
      "data-testid": "composer-cancel-".concat(composer.id),
      onClick: function onClick() {
        trackEvent(ANALYTICS_EVENTS.COMPOSER_CANCEL, {
          composerId: composer.id
        });
        close(composer.id);
      }
    }, t("cancel", {
      defaultValue: "Cancel"
    })), /*#__PURE__*/React.createElement(Button, {
      "data-testid": "composer-save-".concat(composer.id),
      onClick: function onClick() {
        trackEvent(ANALYTICS_EVENTS.COMPOSER_SAVE, {
          composerId: composer.id
        });
        close(composer.id);
      }
    }, t("save", {
      defaultValue: "Save"
    })))
  }, /*#__PURE__*/React.createElement(FormTextarea, {
    label: t("composer_body_label", {
      defaultValue: "Content"
    }),
    minRows: 10,
    placeholder: t("composer_body_placeholder", {
      defaultValue: "Type or paste here…"
    }),
    value: composer.content,
    onChange: function onChange(event) {
      return setContent(composer.id, event.currentTarget.value);
    },
    onBlur: function onBlur() {
      return trackEvent(ANALYTICS_EVENTS.COMPOSER_CONTENT, {
        composerId: composer.id
      });
    },
    "data-testid": "composer-content-".concat(composer.id)
  }));
}